export const DEFAULT_DISCOUNT_NOMINAL_TYPE = 'nominal';
export const DEFAULT_DISCOUNT_PERCENTAGE_TYPE = 'percentage';
